const configurationReducer = (state, action) => {
  switch (action.type) {
    case "update":
      if (action.configValue) {
        return {
          ...state,
          ...action.configValue,
        }
      }
      return state
    case "remove":
      action.configValue.map(x => (state[x] = ""))
      return state
    case "resurrect":
      return action.config
    case "reset":
      return initialConfigState
    default:
      break
  }
}

export default configurationReducer

const initialConfigState = {
  xkit: "",
  // activeFunctionNone: "",
  // activeFunctionActive: "",
  // activeFunctionActivePlus: "",
  hcuSwitch: "no",
  cturn: "",
  boatLength: "",
  hullType: "",
  starboardInterceptors: "",
  centerInterceptors: "",
  steeringInterceptors: "",
  allSpeedFins: "",
  mainCPCable: "",
  servoCable: "",
  finServoCable: "",
  hcuRcuCables: "",
  finHcuRcuCables: "",
  hcuHcuCables: "",
  softwareComfort: "no",
  softwareComfortPlus: "no",
  softwareDynamic: "no",
  softwareDynamicPlus: "no",
  softwareProfessional: "no",
  softwareProfessionalPlus: "no",
  softwareNoSoftware: "no",
  softwareCruise: "no",
  softwareCruiseProfessional: "no",
  softwareUltimate: "no",
  softwareUltimateProfessional: "no",
  softwareCatamaranProfessional: "no",
}
